export function matchesSearch(sourceString: string, searchString: string) {
  const source = sourceString.toLowerCase()
  const terms = searchString
    .toLowerCase()
    .split(/\s+/)
    .map((s) => s.trim())
    .filter((s) => !!s)
  for (const term of terms) {
    if (!source.includes(term)) return false
  }
  return true
}

export function humanJoin(iterable: Iterable<string>, glue: string, lastGlue: string) {
  const array = Array.from(iterable)

  if (array.length === 0) return ''
  if (array.length === 1) return array[0]
  if (array.length === 2) return array.join(lastGlue)

  const lastValue = array.pop() as string
  return `${array.join(glue)}${lastGlue}${lastValue}`
}

export function removePrefix(str: string, prefix: string) {
  return str.startsWith(prefix) ? str.slice(prefix.length) : str
}
